export function initialDataMapper(doc) {
  return {
    documentType: doc?.documentType ?? doc?.document_type ?? null,
    file: doc?.file ?? null,
    fileName: doc?.fileName ?? doc?.file_name ?? "",
    id: doc?.id ?? "",
    provider: doc?.provider ?? null,
    referralFrom: doc?.referralFrom ?? doc?.referral_from ?? null,
    referralTo: doc?.referralTo ?? doc?.referral_to ?? null,
    source: doc?.source ?? null,
  };
}

export function validateDocType(value, documentValidation, setSupportedFiles, setRequiredFields) {
  const validExtensions = documentValidation?.validExtensions;
  const isSourceRequired = documentValidation?.required?.source?.includes(value);
  const isReferralFromRequired = documentValidation?.required?.referral_from?.includes(value);
  const isReferralToRequired = documentValidation?.required?.referral_to?.includes(value);
  const isProviderRequired = documentValidation?.required?.provider?.includes(value);

  setSupportedFiles(validExtensions[value].join(", "));
  setRequiredFields((prev) => ({
    ...prev,
    source: isSourceRequired,
    provider: isProviderRequired,
    referralFrom: isReferralFromRequired,
    referralTo: isReferralToRequired,
  }));
}

export function filterOptionsByLabel(opts, state) {
  if (state.inputValue === "") {
    return opts;
  }

  return opts.filter((opt) => {
    const label = opt?.label?.toString().toLowerCase() || "";
    const input = (state.inputValue || "").toLowerCase();
    return label.includes(input);
  });
}
